<template>
  <div class="heading d-md-flex d-none">
    <div class="heading__column -code">{{ $t("training.program.training_period.heading.code") }}</div>
    <div class="heading__column -label">{{ $t("training.program.training_period.heading.label") }}</div>
    <div class="heading__column -type">{{ $t("training.program.training_period.heading.type") }}</div>
    <div class="heading__column -obl">{{ $t("training.program.training_period.heading.required") }}</div>
    <div class="heading__column -hours">{{ $t("training.program.training_period.heading.hours") }}</div>
    <div class="heading__column -ects">{{ $t("training.program.training_period.heading.ects") }}</div>
    <div class="heading__column -coef">{{ $t("training.program.training_period.heading.coef") }}</div>
    <div class="heading__column -actions">{{ $t("training.program.training_period.heading.actions") }}</div>
  </div>
</template>

<script>
export default {
  name: "TrainingSemesterHeadingComponent",
};
</script>

<style lang="scss" scoped>
.heading {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px dashed $m_color_6;
  font-weight: 600;
  text-transform: uppercase;
  padding-left: 25px;

  &__column {
    width: 8%;
    padding: 5px 10px;
    text-align: center;
    color: var(--primary-color);

    @include dark-theme {
      color: $white;
    }

    &.-label {
      width: 44%;
      text-align: left;
    }

    &.-code {
      text-align: left;
    }
  }
}
</style>
